module.exports = __webpack_public_path__ + "static/media/partner-agents-banner.e2a66ac4.png";